// extracted by mini-css-extract-plugin
export default {"root":"_39vud3BQ","element":"_1pNHzTmM"};